import { nameof } from "../../../../utils/nameof";
import { DescribeMissingField, itemField } from "../../utils/missingFields.utils";
import { AssetRelativesFormValues } from "./RelativesView.types";

const DEPENDANTS = nameof<AssetRelativesFormValues>("dependants");

export const describeMissingDependantField: DescribeMissingField<AssetRelativesFormValues> = (missing, values) =>
  itemField(DEPENDANTS, values.dependants, missing);
